import * as React from "react";
import styled from "@emotion/styled";
//import { css } from "@emotion/core";
import Row, { Col } from '../components/flexgrid';
import { string } from "prop-types";

const Question = styled.div`
    position: relative;
    
`
const Questiontext = styled.div`
    color: black;
    font-size: 16px;
    line-height: 28px;
    font-family: Merriweather;
    height: 54vh;
`
const Count = styled.div`
    text-align: right;
    color: #D1DAE2;
`
const Author = styled.div`
    
`
const Meta = styled.div`
    color: #70777f;
    font-family: Rajdhani;
    text-transform: uppercase;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
`

export default props => {
  const displayCount = String(props.count);
  const numZeros = 3 - displayCount.length;
  return (
    <Question>
      <Questiontext>{props.question}</Questiontext>
      <Meta>
        <Row gutterWidth="0">
          <Col>
            <Author>{props.author}</Author>
          </Col>
          <Col>
          
            <Count>{"0".repeat(numZeros)}{props.count}</Count>
          </Col>
        </Row>
      </Meta>
      
      
    </Question>
  );
};
